import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { Card, CardBody } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { toastError } from "../../helpers/msg_helper"
import { getDeveloperHub } from "../../services/developer"
import "../Tenancy/tenancy.css"
import "./developer.css"

/**
 * Developer hub — the hidden, vendor-only 4-card landing. Mirrors StaffFlow's
 * "System" developer cards (Application Settings, Modules, Settings Manager,
 * Documents Manager). Gated server-side by the `developer` middleware and in the
 * sidebar by company_context.is_developer.
 */
const DeveloperHub = () => {
  document.title = "Developer | Everrise"
  const [cards, setCards] = useState([])

  useEffect(() => {
    ;(async () => {
      try {
        const r = await getDeveloperHub()
        setCards(r?.cards || [])
      } catch (e) {
        toastError(e?.message || "Failed to load developer hub")
      }
    })()
  }, [])

  return (
    <div className="page-content tnt-scope">
      <div className="container-fluid">
        <Breadcrumbs
          title="Developer"
          breadcrumbObject={[
            { title: "Developer", link: "#" },
            { title: "Settings", link: "#" },
          ]}
        />
        <div
          className="dev-hub"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
            gap: "1.25rem",
            alignItems: "start",
          }}
        >
          {cards.map(c => (
            <Link to={c.href} className="dev-card-link" key={c.key}>
              <Card className="dev-card mb-0">
                <CardBody>
                  <div className="d-flex justify-content-between align-items-start">
                    <h5 className="dev-card-title mb-2">{c.title}</h5>
                    {c.count !== null && c.count !== undefined && (
                      <span className="dev-card-count">{c.count}</span>
                    )}
                  </div>
                  <p className="dev-card-desc mb-0">{c.description}</p>
                </CardBody>
              </Card>
            </Link>
          ))}
          {!cards.length && <p className="text-muted">No developer tools available.</p>}
        </div>
      </div>
    </div>
  )
}

export default DeveloperHub
